/* eslint-disable */
"use strict";

import { QFUtil } from "./../../components/util.js";

var QFLayoutSubheader = function() {
    // Private properties
    var _element;

    // Private functions
    var _getHeight = function() {
        var height = 0;

        if (_element) {
            height = QFUtil.actualHeight(_element);
        }

        return height;
    }

    // Public methods
	return {
		init: function(id) {
            _element = QFUtil.getById(id);

            if (!_element) {
                return;
            }
		},

        isFixed: function() {
            return QFUtil.hasClass(QFUtil.getBody(), 'subheader-fixed');
        },

        getElement: function() {
            return _element;
        },

        getHeight: function() {
            return _getHeight();
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = QFLayoutSubheader;
}

export default QFLayoutSubheader;